import { defineComponent as v, useSlots as k, openBlock as e, createElementBlock as o, createElementVNode as c, unref as a, renderSlot as h, createBlock as s, resolveDynamicComponent as r, toDisplayString as l, createCommentVNode as i, withCtx as m, createTextVNode as u } from "vue";
import g from "./ghl-ui.es187.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es277.js";
import y from "./ghl-ui.es69.js";
const C = { class: "hl-empty" }, S = {
  key: 1,
  class: "hl-empty-icon-container"
}, x = { class: "hl-empty-icon" }, T = {
  key: 2,
  class: "hl-empty-title"
}, $ = {
  key: 3,
  class: "hl-empty-description"
}, I = { class: "hl-empty-actions" }, B = v({
  name: "UIEmpty",
  inheritAttrs: !1
}), E = v({
  ...B,
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    positiveText: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: g
    },
    negativeText: {
      type: String,
      default: ""
    },
    positiveIcon: {
      type: Function,
      default: () => ""
    }
  },
  setup(t) {
    const p = k();
    return (d, n) => (e(), o("div", C, [
      c("div", null, [
        a(p).media ? h(d.$slots, "media", { key: 0 }) : (e(), o("div", S, [
          c("div", x, [
            (e(), s(r(t.icon), { class: "w-5 h-6" }))
          ])
        ])),
        t.title ? (e(), o("div", T, l(t.title), 1)) : i("", !0),
        t.description ? (e(), o("div", $, l(t.description), 1)) : i("", !0)
      ]),
      c("div", I, [
        t.negativeText ? (e(), s(a(y), {
          key: 0,
          id: `${t.id}-btn-negative-action`,
          onClick: n[0] || (n[0] = (f) => d.$emit("negativeClick"))
        }, {
          default: m(() => [
            u(l(t.negativeText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : i("", !0),
        t.positiveText ? (e(), s(a(y), {
          key: 1,
          id: `${t.id}-btn-positive-action`,
          type: "primary",
          onClick: n[1] || (n[1] = (f) => d.$emit("positiveClick"))
        }, {
          default: m(() => [
            t.positiveIcon ? (e(), s(r(t.positiveIcon), {
              key: 0,
              class: "w-5 h-6"
            })) : i("", !0),
            u(" " + l(t.positiveText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : i("", !0)
      ])
    ]));
  }
}), D = E;
export {
  D as default
};
